<template>
  <div class="zcbody" v-loading="loading">
    <div class="zc-header">
      <div class="head">
        <div class="logo"><img src="../../assets/images/logo.png" /></div>
        <span class="logintext">认养一头牛SRM供应商管理平台</span>
      </div>
    </div>
    <div class="contaner">
      <div style="text-align:center;">

        <div class="ribbon" style="margin-top:20px;">
          <a><span><img src="../../assets/images/sy-list1.png">用户信息</span></a>
          <a class="active"><span><img src="../../assets/images/sy-list2.png">供货信息</span></a>
          <a><span><img src="../../assets/images/sy-list3.png">上传资质</span></a>
        </div>
      </div>
      <div class="protocol-title">供货对象信息</div>
      <div class="protocont">
        <span style="color: #949494" class="prospan">您的供货对象:下列组织机构有哪些符合您的供货目标?您可以参考组织机构所处的地理位置进行选择。</span>

        <el-table ref="multipleTable" :data="GetALLtable" max-height="420" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" @row-click="handleRowClick" :header-cell-style="{ textAlign: 'center' }">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="公司名称" prop="cztname"></el-table-column>
          <el-table-column label="公司地址" prop="caddress"></el-table-column>
        </el-table>

      </div>
      <div class="protocol-title">
        供货物资或者服务<span style="color:red;font-size:14px">(只能选择一种物料)</span>
        <el-button size="mini" type="success" class="pull-right" @click="addtable">新增</el-button>
      </div>
      <div class="protocol-accept1">
        <span><b></b></span>
      </div>
      <div class="protocont">
        <el-table ref="suppleTable" :data="suppliestable" border max-height="420" tooltip-effect="dark" style="width: 100%" :header-cell-style="{ textAlign: 'center' }">
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column label="类别名称" prop="cclassname"></el-table-column>
          <el-table-column prop="name" label="操作" width="160">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="del(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="zc_btn">
        <el-button type="success" round @click="prereturn()">上一步</el-button>
        <el-button type="success" round @click="clickSubmit()">下一步</el-button>
      </div>
    </div>
    <tree v-if="treeif" :suppliestable="suppliestable" @supplie="supplie" :treeif="treeif" />
  </div>
</template>

<script>
import tree from "./SupplyObject/tree.vue";

export default {
  components: {
    tree,
  },
  data() {
    return {
      treeif: false,
      loading: false,
      urlid: "",
      GetALLtable: [],
      suppliestable: [],
      comdata: [],
    };
  },
  created() {
    console.log(window.localStorage.getItem("userdata"));
    if (JSON.parse(window.localStorage.getItem("userdata")).id) {
      this.urlid = JSON.parse(window.localStorage.getItem("userdata")).id;
      this.GetALL();
    } else {
      this.$message.error("您还没有登录，请登录");
      setTimeout(() => {
        this.$router.push({ name: "login" });
      }, 200);
    }
  },
  methods: {
    handleRowClick(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    // 判断刷新
    listenPage() {
      window.onbeforeunload = function (e) {
        e = e || window.event;
        if (e) {
          console.log("5464");
          sessionStorage.removeItem("jsondata");
          sessionStorage.removeItem("suppliestable");
          e.returnValue = "关闭提示";
        }
        return "关闭提示";
      };
    },
    GetCusInvClass() {
      // suppliestable
      // console.log(JSON.parse(sessionStorage.getItem("jsondata")), "548489");
      if (sessionStorage.getItem("suppliestable") != null) {
        this.suppliestable = JSON.parse(
          sessionStorage.getItem("suppliestable")
        );
        var comdata = eval(JSON.parse(sessionStorage.getItem("jsondata")));
        comdata = JSON.parse(
          JSON.stringify(comdata)
            .replace(/"cpasturecode"/g, '"cztcode"')
            .replace(/"cpasturename"/g, '"cztname"')
        );
        var list = {};
        console.log(comdata);
        for (var a = 0; a < comdata.length; a++) {
          if (comdata[a].caddress) {
            list = {
              cztcode: comdata[a].cztcode,
              cztname: comdata[a].cztname,
              caddress: comdata[a].caddress,
            };
          } else {
            list = { cztcode: comdata[a].cztcode, cztname: comdata[a].cztname };
          }
          this.comdata.push(list);
        }

        this.toggleSelection(this.comdata);
      } else {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetCusInvClass",
          data: { KeyValue: this.urlid },
        }).then((res) => {
          console.log(res, "urlid");
          if (res.data.Success) {
            var comdata = eval(res.data.Data.data2);
            comdata = JSON.parse(
              JSON.stringify(comdata)
                .replace(/"cpasturecode"/g, '"cztcode"')
                .replace(/"cpasturename"/g, '"cztname"')
            );
            var list = {};
            for (var a = 0; a < comdata.length; a++) {
              if (comdata[a].caddress) {
                list = {
                  cztcode: comdata[a].cztcode,
                  cztname: comdata[a].cztname,
                  caddress: comdata[a].caddress,
                };
              } else {
                list = {
                  cztcode: comdata[a].cztcode,
                  cztname: comdata[a].cztname,
                };
              }
              this.comdata.push(list);
            }
            this.suppliestable = res.data.Data.data1;
            this.toggleSelection(this.comdata);
          } else {
            this.$message.error(res.data.Message);
          }
        });
      }
    },
    toggleSelection(rows) {
      console.log(rows);
      var that = this;
      rows = JSON.parse(JSON.stringify(rows));
      that.$nextTick(() => {
        if (that.$refs.multipleTable) {
          that.$refs.multipleTable.clearSelection();
        }
        var arr = this.GetALLtable;
        rows.forEach((row) => {
          for (let j in arr) {
            if (row.cztcode == arr[j].cztcode) {
              console.log(row);
              that.$refs.multipleTable.toggleRowSelection(arr[j], true);
              break;
            }
          }
        });
      });
    },

    // 删除
    del(row, index) {
      this.suppliestable.splice(index, 1);
    },
    // 父子传值
    supplie(val, val1) {
      if (val != 1) {
        this.suppliestable = val;
      }
      this.treeif = val1;
    },
    // 返回上一步
    prereturn() {
      this.$router.push({ path: "/UserCenterinfoNot" });
    },
    handleSelectionChange(val) {
      this.comdata = val;
    },
    //  获取全部公司
    GetALL() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetALL",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.GetALLtable = res.data.Data;
          this.GetCusInvClass();
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    addtable() {
      this.treeif = true;
    },
    clickSubmit() {
      var jsondata = eval(this.comdata);
      jsondata = JSON.parse(
        JSON.stringify(jsondata)
          .replace(/"cztcode"/g, '"cpasturecode"')
          .replace(/"cztname"/g, '"cpasturename"')
      );
      console.log(this.suppliestable, jsondata);
      if (this.comdata.length != 0 && this.suppliestable.length != 0) {
        sessionStorage.setItem("jsondata", JSON.stringify(jsondata));
        sessionStorage.setItem(
          "suppliestable",
          JSON.stringify(this.suppliestable)
        );
        // UserCenterWareEnd
        this.$router.push({ path: "/UserCenterWareEnd" });
      } else {
        this.$message.error("请选择供货目标公司或者物料信息");
      }
    },
  },

  mounted() {
    this.listenPage();
  },
};
</script>
<style scoped>
@import url(../../assets/css/reg.css);
</style>